export default __webpack_public_path__ + "static/media/equipe.0ad254fa.jpg";